import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import InsightsGrid from "@/components/InsightsGrid";

export default function Insights() {
  return (
    <>
      <Seo
        title="Insights | Incremental Consulting"
        description="Perspectives on delivery assurance, regulatory programmes, PMO governance and flow from Incremental Consulting."
      />
      <section className="bg-[#0B1F3A]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#C9A227]" data-testid="insights-eyebrow">Insights</p>
            <h1 className="mt-3 max-w-3xl text-balance font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="insights-page-title">
              Thinking on better delivery.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70">
              Perspectives on delivery assurance, regulatory programmes, PMO governance and flow. New articles are on the way.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F5F8FC]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-testid="insights-page-list">
          <InsightsGrid testIdPrefix="insights-page" limit={24} />
        </div>
      </section>

      <section className="bg-[#0B1F3A]" data-testid="insights-notify-cta">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
          <Reveal className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <h2 className="max-w-xl text-balance font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Want these in your inbox when they land?
            </h2>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="mailto:takunda.noha@incrementalconsulting.co.za?subject=Notify%20me%20when%20new%20insights%20land"
                data-testid="insights-notify-email"
                className="inline-flex items-center gap-2 rounded-md bg-[#C9A227] px-7 py-3.5 text-sm font-bold text-[#0B1F3A] transition-colors duration-200 hover:bg-[#DDB845]"
              >
                <Mail size={15} />
                Email us to be notified
              </a>
              <Link
                to="/contact"
                data-testid="insights-notify-contact"
                className="group inline-flex items-center gap-2 rounded-md border border-white/30 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-[#C9A227] hover:text-[#C9A227]"
              >
                Start a conversation
                <ArrowRight size={15} className="transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
